import styled, { keyframes } from 'styled-components';

import THEME from '../../assets/styles/config';

const slide = keyframes`
  0% {
    left: -40%;
  }

  100% {
    left: 100%;
  }
`;

export const Ctn = styled.div<{ large: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: stretch;

  // The full width of the place it sits in, from its left edge: the portal's content is left-aligned, and a bar centred
  // in a narrower box floated away from the heading above it (seen on the site-selection page, 21 Oct 2026).
  width: 100%;
  padding: ${(props) => (props.large ? '48px 0' : '16px 0')};
`;

export const Track = styled.div`
  position: relative;
  width: 100%;
  height: 8px;
  overflow: hidden;
  border-radius: 4px;
  background: #e3eef5;
`;

export const Slider = styled.div`
  position: absolute;
  top: 0;
  width: 40%;
  height: 100%;
  border-radius: 4px;
  background: ${THEME.colors.primaryColor};
  animation: ${slide} 1.4s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    left: 0;
    width: 100%;
    animation: none;
    opacity: 0.6;
  }
`;
